import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const categoriaImporterSelectors = importerSelectors(
  'categoria.importer',
);

export default categoriaImporterSelectors;
